import { CoreFetch, DocumentApi, ListProviderDocumentsRequest, ProviderDocument } from '@enter/core';
import { IItemListing } from './root.store';
import { fetch, parseResponse } from './util';

export class DocumentService {
    public async fetchDocumentListing(
        lpgr: ListProviderDocumentsRequest,
    ): Promise<IItemListing<ProviderDocument> | undefined> {
        const res = await fetch(lpgr, req =>
            CoreFetch<DocumentApi>(DocumentApi).listProviderDocumentsRaw({ filterActive: `EQ:1`, ...req }),
        );
        if (res) {
            return {
                items: await parseResponse(res),
                limit: Number(await res.raw.headers.get('pagination-limit')),
                offset: Number(await res.raw.headers.get('pagination-offset')),
                total: Number(await res.raw.headers.get('pagination-total')),
            };
        }
    }
}
